import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../components/common/Button';

const AboutUsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  return (
    <div className="max-w-4xl mx-auto p-4">
      <div className="bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold text-center text-blue-700 mb-6">
          {t('aboutUs.title')}
        </h1>
        
        <div className="space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-blue-800 mb-3">
              {t('aboutUs.ourTeam')}
            </h2>
            <p className="text-gray-700">
              {t('aboutUs.teamDescription')}
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-blue-800 mb-3">
              {t('aboutUs.ourMission')}
            </h2>
            <p className="text-gray-700">
              {t('aboutUs.missionDescription')}
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-blue-800 mb-3">
              {t('aboutUs.researchDevelopment')}
            </h2>
            <p className="text-gray-700">
              {t('aboutUs.researchDescription')}
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold text-blue-800 mb-3">
              {t('aboutUs.contactInfo')}
            </h2>
            <div className="space-y-2 text-gray-700">
              <p><strong>{t('aboutUs.address')}</strong> {t('aboutUs.addressValue')}</p>
              <p><strong>{t('aboutUs.email')}</strong> {t('aboutUs.emailValue')}</p>
              <p><strong>{t('aboutUs.phone')}</strong> {t('aboutUs.phoneValue')}</p>
            </div>
          </section>
        </div>
        
        <div className="mt-8 flex justify-center">
          <Button
            onClick={() => navigate('/')}
            className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded"
          >
            {t('aboutUs.backToHome')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AboutUsPage;